import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/react-hooks";
import { Link as RouterLink } from "@reach/router";
import { ad2bs } from "@aseemregmi/ad-bs-converter";
import Helmet from "react-helmet";
import "medium-draft/lib/index.css";

import { navBarContext } from "../../../contexts/navBarContext";
import ActivityLoader from "../../ActivityLoader";
import NameLogo from "../../utility/NameLogo";
import ShareButtons from "../../ShareButtons";
import NotFound from "../NotFound";

import { GET_EPAPER_BY_PERMALINK } from "../../../QUERY/QUERY/epaper";
import EpaperView from "./EpaperView";

const Epaper = (props) => {
  const { setTopNavMiddleContent } = useContext(navBarContext);

  useEffect(() => {
    setTopNavMiddleContent(
      <RouterLink style={{ height: "70%", display: "flex" }} to="/">
        <NameLogo />
      </RouterLink>
    );
  }, []);

  const uri = props.uri.toLowerCase();

  const { data, error, loading } = useQuery(GET_EPAPER_BY_PERMALINK, {
    variables: { permalink: uri },
  });

  if (loading) {
    return <ActivityLoader />;
  }

  if (error) {
    return <NotFound />;
  }

  if (!data.getEpaper) {
    return <NotFound />;
  }

  const { getEpaper: epaper } = data;

  let date = "",
    displayDate = "";

  if (epaper.date) {
    date = ad2bs(
      `${new Date(parseInt(epaper.date)).getFullYear()}/${
        new Date(parseInt(epaper.date)).getMonth() + 1
      }/${new Date(parseInt(epaper.date)).getDate()}`
    ).ne;

    displayDate = `${date.strDayOfWeek
      .replace("मगल", "मंगल")
      .replace("वार", "बार")}, ${date.strMonth} ${date.day}, ${date.year}`;
  }

  return (
    <PostContainer>
      <Helmet>
        <meta
          name="description"
          content={`${epaper.heading} | नयाँ युगबोध राष्ट्रिय दैनिकको इ-पेपर`}
        />
        <meta
          property="og:url"
          content={`https://nayayougbodh.com${epaper.permalink}`}
        />
        <meta property="og:type" content="epaper" />
        <meta property="og:title" content={epaper.heading} />
        <title>{epaper.heading} | नयाँ युगबोध राष्ट्रिय दैनिक</title>
        <meta
          property="og:description"
          content={`${epaper.heading} | नयाँ युगबोध राष्ट्रिय दैनिकको इ-पेपर`}
        />
        <meta content="summary_large_image" name="twitter:card" />
        <meta
          property="og:image"
          content={"https://nayayougbodh.com/images/logo-1569914602475.png"}
        />
        <meta property="twitter:site" content="@yougbodh" />
        <meta property="twitter:creater" content="@yougbodh" />
        <meta property="twitter:title" content={epaper.heading} />
        <meta
          property="twitter:description"
          content={`${epaper.heading} | नयाँ युगबोध राष्ट्रिय दैनिकको इ-पेपर`}
        />
        <meta
          property="description"
          content={`${epaper.heading} | नयाँ युगबोध राष्ट्रिय दैनिकको इ-पेपर`}
        />
        <meta
          property="twitter:image"
          content={"https://nayayougbodh.com/images/logo-1569914602475.png"}
        />
        <link
          rel="canonical"
          href={`https://nayayougbodh.com${epaper.permalink}`}
        />
      </Helmet>
      <ArticleContainer>
        <Heading>{epaper.heading}</Heading>
        <AuthorsContainer>
          {epaper.date ? <DateContainer>{displayDate}</DateContainer> : null}
        </AuthorsContainer>
        <EpaperView url={epaper.file} />
        <ShareButtons permalink={epaper.permalink} />
      </ArticleContainer>
    </PostContainer>
  );
};

const PostContainer = styled.div`
  max-width: 120rem;
  padding: 5rem 10rem;
  padding-bottom: 0;
  margin: 0 auto;

  @media (max-width: 750px) {
    padding: 5rem;
    padding-bottom: 0;
  }

  @media (max-width: 450px) {
    padding: 5rem 2rem;
    padding-bottom: 0;
  }
`;

const ArticleContainer = styled.div`
  max-width: 80rem;
  margin: 0 auto;
  font-size: 1.75rem;
`;

const Heading = styled.h1`
  font-size: 5rem;
  line-height: 1.25;
`;

const AuthorsContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  border-bottom: 1px solid #dfdfdf;
  padding-bottom: 1rem;
  flex-wrap: wrap;
`;

const DateContainer = styled.time`
  // align-self: stretch;
  margin-right: 2rem;
  padding-right: 1rem;
  border-right: 1px solid #dfdfdf;
  color: #555;
`;
export default Epaper;
